import React from "react";
import "../../assets/scss/my_disclaimer.scss";

const MyDisclaimer = ({ text }) => {
    return (
        <div
            className={`my_disclaimer`}
        >
            {text}
        </div>
    );
};

export default MyDisclaimer;
